import _ from 'underscore';
import $ from 'jquery';
import 'jquery.cookie';
import Backbone from 'backbone';

const root = window || {};

root._ = _;
Backbone.$ = $;
root.$ = $;
root.jQuery = $;

export default Backbone;



// WEBPACK FOOTER //
// ./static-source/js/lib/backbone.js